import styles from './icon-button.module.scss';
import MaterialIconButton from '@mui/material/IconButton';

/* eslint-disable-next-line */
export interface IconButtonProps {
  children: any,
  // classes?: object,
  color?: 'inherit' | 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',
  disabled?: boolean,
  // disableFocusRipple?: boolean,
  // disableRipple?: boolean,
  edge?: 'end' | 'start' | false,
  size?: 'small' | 'medium' | 'large',
  sx?: any,
  className?: string,
  onClick?: (...args: any[]) => void
}

export function IconButton(props: IconButtonProps) {
  return (
    <MaterialIconButton
      color={props.color}
      disabled={props.disabled}
      edge={props.edge}
      size={props.size}
      sx={props.sx}
      className={props.className}
      onClick={props.onClick}>
      {props.children}
    </MaterialIconButton>
  );
}

export default IconButton;